import {call, put} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {BookPayload} from '../../@types/actions';
import {BOOK_EVENT_ERROR, BOOK_EVENT_SUCCESS} from "../../constants/LiveConstants";
import {BookLiveCall} from "../../apis/user";

function* tryFunction(payload: BookPayload) {
    yield call(BookLiveCall, payload);
    const alertKey = payload.sbv && payload.sbv !== '#'
        ? `${payload.eventId}-${payload.marketId}@${payload.sbv}-${payload.signId}`
        : `${payload.eventId}-${payload.marketId}-${payload.signId}`
    yield put({
        type: BOOK_EVENT_SUCCESS,
        payload: alertKey
    });
}

export function* bookLiveSaga({payload}: { payload: BookPayload }): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction, payload: payload},
        failedType: BOOK_EVENT_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}
